import { PaidSubscription, SubscriptionType } from "../common/subscription";

export function canRenderAdminProjects(subscription?: PaidSubscription) {
  return canRenderAllFunctions(subscription);
}

export function canRenderAdminMeetings(subscription?: PaidSubscription) {
  return canRenderAllFunctions(subscription);
}

export function canRenderArchive(subscription?: PaidSubscription) {
  return canRenderAllFunctions(subscription);
}

export function canRenderMessages(subscription?: PaidSubscription) {
  return canRenderAllFunctions(subscription);
}

function canRenderAllFunctions(subscription?: PaidSubscription) {
  return (
    !subscription || subscription.subscriptionType !== SubscriptionType.SHAREHOLDER_REGISTER_LEGACY
  );
}
